<template>
    <div style="padding-bottom: 2.5rem;">
        <div class="orderList">{{ $t('meg.orderList') }}</div>
        <div style="margin-left: .3875rem;margin-top: .3rem;">
            <ul class="status" style="display: flex;gap: 1.05rem;">
                <li :class="{ active: orderStatus === 5 }" @click="changeTab(5)" v-if="roleType == 1">{{ $t('meg.LetterIntent') }}</li>
                <li :class="{ active: orderStatus === '' }" @click="changeTab('')">{{ $t('meg.whole') }}</li>
                <li :class="{ active: orderStatus === 1 }" @click="changeTab(1)">{{ $t('meg.Toproduced') }}</li>
                <li :class="{ active: orderStatus === 2 }" @click="changeTab(2)">{{ $t('meg.Production') }}</li>
                <!-- <li :class="{ active: orderStatus === 4 }" @click="changeTab(4)">{{ $t('meg.evaluated') }}</li> -->
                <li :class="{ active: orderStatus === 3 }" @click="changeTab(3)">{{ $t('meg.finished') }}</li>
            </ul>
        </div>
        <div style="margin-top: .4375rem;margin-left: .3875rem;margin-right: .3rem;">
            <el-table v-if="orderStatus == 5" :data="tableData" style="width: 100%"
                :header-cell-style="{ 'background': '#EEEEEE !important', 'color': '#333', 'height': '.7rem !important' }">
                <el-table-column type="index" :label="$t('meg.Serial')" width="180" />
                <el-table-column prop="materialTime" :label="$t('meg.arrivaltime')" width="260px" />
                <el-table-column prop="shipmentTime" :label="$t('meg.shippingtime')" width="220" />
                <el-table-column prop="shipmentDestination" :label="$t('meg.destination')" />
                <el-table-column prop="orderNumber" :label="$t('meg.orderNum')" width="220" />
                <!-- <el-table-column prop="orderState" label="订单状态" /> -->
                <el-table-column label="操作">
                    <template #default="scope">
                        <el-button link type="primary" size="small" class="caozuoBtn"
                            @click="detail(scope.row.devlieryId, 2)">{{ $t('meg.Detail') }}</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-table v-if="orderStatus != 5" :data="tableData" style="width: 100%"
                :header-cell-style="{ 'background': '#EEEEEE !important', 'color': '#333', 'height': '.7rem !important' }">
                <el-table-column type="index" :label="$t('meg.Serial')" width="180" />
                <el-table-column prop="materialTime" :label="$t('meg.arrivaltime')" width="260px" />
                <el-table-column prop="shipmentTime" :label="$t('meg.shippingtime')" width="220" />
                <el-table-column prop="shipmentDestination" :label="$t('meg.destination')" />
                <el-table-column prop="orderNumber" :label="$t('meg.orderNum')" width="220" />
                <!-- <el-table-column prop="orderState" label="订单状态" /> -->
                <el-table-column :label="$t('meg.Operation')">
                    <template #default="scope">
                        <el-button v-if="roleType == 1" link type="primary" size="small" class="caozuoBtn"
                            @click="handleClick(scope.row.orderId, 1,1)">{{ $t('meg.Detail') }}</el-button>
                            <el-button  v-if="roleType == 2" link type="primary" size="small" class="caozuoBtn"
                            @click="handleClick(scope.row.orderId, 1,2)">{{ $t('meg.Detail') }}</el-button>
                        <el-button v-if="roleType == 2 && scope.row.orderState == 1" link type="primary" size="small"
                            class="caozuoBtn" @click="acceptOrder(scope.row.orderId)">{{ $t('meg.receiveOrder') }}</el-button>
                            <el-button v-if="orderStatus == 2" link type="primary" size="small"
                            class="caozuoBtn" @click="history(scope.row)">{{ $t('meg.prog ') }}</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        
    <!-- 历史记录弹窗 -->
    <el-dialog v-model="historyDialog" title="生产进度反馈" :before-close="handleClose" style="padding-left: .625rem;padding-right: .625rem;padding-bottom: .625rem;">
      <el-form :model="historyForm">
        <el-date-picker v-model="historyForm.date" type="date" placeholder="选择日期" value-format="YYYY-MM-DD"
          @change="pickBtn">
        </el-date-picker>
      </el-form>
      <div style="display: flex;justify-content: space-between;margin-top: .375rem;margin-bottom: .125rem;">
        <p>{{ $t('meg.today') }}：{{ today }}</p>
        <p>{{ $t('meg.DeliveryDate') }}：{{ shipmentTime }}</p>
      </div>
      <div class="tableBox" style="margin-bottom: .375rem;">
        <el-table border :data="EmployeeWorkStatisticsList.tableDetails">

          <el-table-column v-for="header in EmployeeWorkStatisticsList.tableHards" :key="header.prop" :label="header.name"
            :prop="header.prop"></el-table-column>
        </el-table>
      </div>
      <p style="text-align: left;" v-if="roleType == 1">{{ $t('meg.remark') }}：{{ remark }}</p>
      <!-- <span slot="footer" class="dialog-footer">
        <el-button @click="cropDialog = false">取 消</el-button>
        <el-button type="primary" @click="cropConfirm">确 定</el-button>
      </span> -->
    </el-dialog>
    <div style="display: flex;justify-content: center;margin-bottom: .25rem;margin-top: .25rem">
      <el-pagination background layout="prev, pager, next" :total="total" :page-size="queryForm.pageSize"
        :current-page="queryForm.pageNum" @current-change="handleCurrentChange" />
    </div>
    </div>
</template>

<script setup>
import { onMounted, reactive, ref } from "vue"
import { orderData, plantOrderData } from "@/api/mange.js"
import { getDicts, factoryAcceptOrder,selectOrderAccomplishByOrderId } from "@/api/order.js"
import { getDetailsData } from "@/api/person.js"
import { useRouter } from 'vue-router';
import { ElMessage, ElMessageBox } from 'element-plus'


const orderStatus = ref(localStorage.getItem("roleType") == 2 ? '' : 5)
const tableData = ref([])
const stateData = ref([])
const total = ref(0)
const historyForm = reactive({
    date:"",
})
const today = ref("")
const remark = ref("")
const shipmentTime = ref("")
const historyId = ref("")
const historyDialog = ref(false)
const EmployeeWorkStatisticsList = ref([])
const router = useRouter()
const roleType = localStorage.getItem("roleType")
onMounted(() => {
    getDicts('order_state').then(res => {
        stateData.value = res.data.data
    })
    if (roleType == 1) {
        getOrderList(5)
    } else if (roleType == 2) {
        plantData('')
    }
})

const queryForm = reactive({
  pageSize: 10,
  pageNum: 1
})
const acceptOrder = (val) => {
    ElMessageBox.confirm(
        '是否确认接此订单，一旦接单，无法更改',
        '提示',
        {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
        }
    ).then(() => {
        factoryAcceptOrder(val).then(res => {
            if (res.data.code == 200) {
                ElMessage.success("接单成功")
                plantData()
            }
        })
    })
}

const changeTab = (index) => {
    orderStatus.value = index
    if (roleType == 1) {
        getOrderList(orderStatus.value)
    } else if (roleType == 2) {
        plantData(orderStatus.value)
    }
}

const getOrderList = (status) => {
    orderData({ orderState: status }).then(res => {
        tableData.value = []
        if (orderStatus.value == 5) {
            if (res.data.code == 200) {
                tableData.value = []
                tableData.value = res.data.rows[0].letterIntent
                total.value = res.data.total
            }
        } else {
            tableData.value = []
            tableData.value = res.data.rows[0].orderManages
            total.value = res.data.total
        }
        stateData.value.map((item, index) => {
            tableData.value.map((val, index) => {
                if (val.orderState == item.dictValue) {
                    val.orderState = item.dictLabel
                }
            })
        })
    })
}

const handleClose = () => {
    historyForm.date = "",
    historyDialog.value = false 
}



const history = (val) => {
    historyId.value = val.orderId
    historyDialog.value = true
    let obj = {
        orderId:  historyId.value,
        startTime: ""
      }
      selectOrderAccomplishByOrderId(obj).then(res => {
        today.value = res.data.data.today
        shipmentTime.value = res.data.data.shipmentTime
        remark.value = res.data.data.remark
        EmployeeWorkStatisticsList.value = res.data.data
      })

}
const pickBtn = () => {
      let obj = {
        orderId: historyId.value,
        startTime: historyForm.date
      }
      selectOrderAccomplishByOrderId(obj).then(res => {
        EmployeeWorkStatisticsList.value = []
        EmployeeWorkStatisticsList.value = res.data.data
      })
}

const plantData = (status) => {
    plantOrderData({ orderState: status }).then(res => {
        tableData.value = []
        tableData.value = res.data.rows
        total.value = res.data.total
        // stateData.value.map((item, index) => {
        //     tableData.value.map((val, index) => {
        //         if (val.orderState == item.dictValue) {
        //             val.orderState = item.dictLabel
        //         }
        //     })
        // })
    })
}

const detail = (devlieryId, type) => {
    router.push({ path: '/orderDetail', query: { devlieryId: devlieryId, type: type } })
}

const handleClick = (orderId, type,roleType) => {
    // router.push("/orderDetail")
    router.push({ path: '/orderDetail', query: { orderId: orderId, type: type,roleType:roleType } })
}

</script>

<style scoped>
.orderList {
    height: .6375rem;
    background: #EEEEEE;
    opacity: 1;
    margin: .3625rem .3rem 0 .3875rem;
    font-size: .2rem;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 700;
    color: #000000;
    line-height: .6375rem;
    text-align: left;
    padding-left: .25rem;
}

.status li {
    font-size: .2rem;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 400;
    color: #3C3C3C;
    padding-bottom: .1375rem;
    cursor: pointer;
}

.active {
    color: #002FA7 !important;
    border-bottom: .025rem solid #002FA7;
    padding-bottom: .125rem;
}

::v-deep .el-table .el-table__cell {
    text-align: center;
}
::v-deep .el-dialog__header {
    padding: 0;
    margin-bottom: .125rem;
}
::v-deep .el-dialog__title {
    font-size: .25rem;
    font-weight: 700;
    
}
</style>
